import PPAdressAutocomplete from "./PPAdressAutocomplete";
import PPaddMessageManagementForGF from "./PPaddMessageManagementForGF";
document.addEventListener("DOMContentLoaded", ()=>{

    let gus = null;
    gus = new GusApi('postalAgentDataFromAPI','input_23_12');
    document.querySelector('#input_23_22').setAttribute('readonly', 'readonly');

    const ppAddressAutocomplete = new PPAdressAutocomplete(
        'input_23_21',
        'input_23_22',
        'input_22',
        'validation_message_23_22'
    );
    ppAddressAutocomplete.main();

    const selects = document.querySelectorAll('select');

    selects.forEach(select => {

        if(select.value && select.value != ''){
            select.classList.add('has-value');
        }

        select.addEventListener('change', function () {
            if (this.value && this.value != '') {
                this.classList.add('has-value');
            } else {
                this.classList.remove('has-value');
            }
        });
    });

    //===================================================================
    const ppMessageManagement =  new PPaddMessageManagementForGF('#gform_23');
    ppMessageManagement.addElementsByID('18');
    ppMessageManagement.setElements();
});

//============================================================================
class GusApi{
    #buttonId = null;
    #inputNipId = null;
    #errorNipContener = null;
    #companyButton = null;
    #apiGroupContener = null;
    #preloaderApi = null;
    #apiData = null;
    #inputPhoneId = null
    #apiUrl = '/wp-content/themes/pp/inc/form-postal-agent/gus.php';
    constructor(buttonId,inputNipId) {

        this.#inputNipId = document.getElementById(inputNipId);
        this.#buttonId = document.getElementById(buttonId);
        this.#companyButton = document.querySelector('input[type="radio"][name="input_10"]');
        this.#inputPhoneId = document.getElementById('input_23_8');
        this.setNipOnlyDigits();
        this.setNipPasteClean();
        this.setNipEvent();
        this.setPhoneEvent();
        this.copyCompanyData();
        this.setCompanyEvent();
        this.#apiGroupContener = document.getElementById('form-postal-agent-api-group');

        this.#inputNipId.addEventListener('input', (e)=>{
            this.resetCompanyData();
        });

        this.#buttonId.addEventListener('click', (e)=>{

            if(this.checkNip()){
                this.getDataFromGus();
            } else {
                this.nipError('Podaj poprawny NIP');
            }

        });
    }

    setNipEvent(){
        this.#inputNipId.addEventListener('input', ()=>{
            this.resetCompanyData();
        });
        this.#inputNipId.addEventListener('paste', ()=>{
            this.resetCompanyData();
        });
    }

    setPhoneEvent(){

        this.#inputPhoneId.addEventListener('keypress', (e)=>{
            if (!/\d/.test(e.key)) {
                e.preventDefault(); // blokuje wpisanie niecyfry
                alert('Wpisz tylko cyfry');
            }
        });

        this.#inputPhoneId.addEventListener('paste',(e)=>{
            e.preventDefault();
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            const cleaned = pastedData.replace(/\D/g, ''); // usuwa wszystko co nie jest cyfrą
            this.#inputPhoneId.value = cleaned;
        });

    }

    setNipPasteClean(){

        this.#inputNipId.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            const cleaned = pastedData.replace(/\D/g, ''); // usuwa wszystko co nie jest cyfrą
            this.#inputNipId.value = cleaned;
        })

    }

    nipErrorClean(){

        if(this.#errorNipContener===null) return;

        this.#errorNipContener.remove();
        this.#inputNipId.setAttribute('aria-invalid', 'false');
        this.#inputNipId.parentNode.parentNode.classList.remove('gfield_error');
    }

    checkNip(){

        if(this.#errorNipContener){
            this.nipErrorClean();
        }

        if(this.#inputNipId.value.length <1) return false;

        let nip = this.#inputNipId.value;
        nip = nip.replace(/[\s-]/g, '');
        if (!/^\d{10}$/.test(nip)) return false;

        const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;

        for (let i = 0; i < weights.length; i++) {
            sum += weights[i] * parseInt(nip[i], 10);
        }

        const controlDigit = sum % 11;
        return controlDigit === parseInt(nip[9], 10);

    }

    nipError(msg) {

        this.#inputNipId.setAttribute('aria-invalid', 'true');
        //<div id="validation_message_23_12" class="gfield_description validation_message gfield_validation_message">To pole jest wymagane.</div>
        this.#errorNipContener = document.createElement('div');
        this.#errorNipContener.id = 'validation_message_23_12';
        this.#errorNipContener.classList.add('gfield_description', 'validation_message', 'gfield_validation_message');
        this.#errorNipContener.textContent = msg;
        this.#inputNipId.parentNode.parentNode.appendChild(this.#errorNipContener);
        this.#inputNipId.parentNode.parentNode.classList.add('gfield_error');

    }

    getDataFromGus(){

        this.showPreloaderNip();
        this.denyCompanyButton();
        this.resetCompanyData();

        fetch(this.#apiUrl,{
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body:JSON.stringify({
                nip:this.#inputNipId.value,
                nonce:ajaxData.nonce
            })
        })
            .then(response => {

                if (!response.ok) {
                    return response.json().then(err => {

                        let message = null;

                        if('undefined'!==typeof err.data){
                            message = err.data.message;
                        } else {
                            message = '(' + response.status + ') ' + response.statusText;
                        }

                        message = (message.length>0) ? message : 'Błąd zapytania';

                        throw new Error(err.error || message);
                    });
                }
                return response.json();
            })
            .then((data)=>{
                if( (data.error && data.error.length>0 && typeof data.error === 'string') || (data.ErrorCode && data.ErrorCode.length>0 && typeof data.ErrorMessagePl === 'string')){
                    if(!this.isEmpty(data.error)){
                        this.nipError(data.error);
                    } else {
                        this.nipError(data.ErrorMessagePl);
                    }

                    this.resetCompanyData();
                } else {
                    this.#apiData = data;
                    this.setCompanyData();
                }

            })
            .catch(error => {
                this.nipError(error.message);
                this.resetCompanyData();
            })
            .finally(()=>{
                    this.hidePreloaderNip();
                    this.allowCompanyButton();
                }
            );
    }

    setNipOnlyDigits(){
        this.#inputNipId.addEventListener('keypress', (e)=>{
            if (!/\d/.test(e.key)) {
                e.preventDefault(); // blokuje wpisanie niecyfry
                alert('Wpisz tylko cyfry');
            }
        })
    }

    setCompanyEvent(){
        document.addEventListener("change", ()=>{
            this.nipErrorClean();
        });
    }

    showPreloaderNip(){
        const div = document.createElement('div');
        div.classList.add('form-postal-agent__preloader-small', 'small', 'active');
        this.#preloaderApi = this.#apiGroupContener.appendChild(div);
    }

    hidePreloaderNip(){
        this.#preloaderApi.remove();
    }

    denyCompanyButton(){
        this.#buttonId.disabled = true;
    }

    allowCompanyButton(){
        this.#buttonId.disabled = false;
    }

    setCompanyData(){

        this.setCompanyItem('#H_regon',this.#apiData.Regon,'#input_23_14');
        this.setCompanyItem('#H_nazwa',this.#apiData.Nazwa, '#input_23_26');
        this.setCompanyItem('#H_kod_pocztowy',this.#apiData.KodPocztowy, '#input_23_27');
        this.setCompanyItem('#H_miejscowosc',this.#apiData.Miejscowosc, '#input_23_28');

        let address = this.setAddress(this.#apiData.Ulica,this.#apiData.NrNieruchomosci,this.#apiData.NrLokalu);
        this.setCompanyItem('#H_adres',address, '#input_23_29');

    }

    setAddress(street, house, flat){

        if (typeof street === "object" && street !== null && Object.keys(street).length === 0) {
            street = '';
        }

        let s = (street ?? '');
        let h = (house ?? '');
        let f = (flat ?? '');
        let ret = null;

        ret = (street ?? '');

        ret += (!this.isEmpty(house)) ? ' ' + house : '';
        ret += (!this.isEmpty(flat)) ? '/' + flat : '';

        return ret;
    }

    copyCompanyData(){
        this.setCompanyItemFromHidden('#input_23_14','#H_regon');
        this.setCompanyItemFromHidden('#input_23_26','#H_nazwa');
        this.setCompanyItemFromHidden('#input_23_27','#H_kod_pocztowy');
        this.setCompanyItemFromHidden('#input_23_28','#H_miejscowosc');
        this.setCompanyItemFromHidden('#input_23_29','#H_adres');
    }

    setCompanyItem(id, value, gfid){
        let item = document.querySelector(id);
        let gfidItem = document.querySelector(gfid);
        if(item){
            item.disabled = false;
            item.readOnly = false;

            item.value = value;

            item.disabled = true;
            item.readOnly = true;
        }
        if(gfidItem){
            gfidItem.value = value;
        }
    }

    setCompanyItemFromHidden(from, to){
        let itemFrom = document.querySelector(from);
        let itemTo = document.querySelector(to);
        itemTo.value = itemFrom.value;
    }

    resetCompanyData(){
        this.#apiData = null;
        this.setCompanyItem('#H_regon','', '#input_23_14');
        this.setCompanyItem('#H_nazwa','', '#input_23_26');
        this.setCompanyItem('#H_kod_pocztowy','', '#input_23_27');
        this.setCompanyItem('#H_miejscowosc','', '#input_23_28');
        this.setCompanyItem('#H_adres','', '#input_23_29');
    }


    isEmpty(value) {
        return (
            value === undefined ||
            value === null ||
            value === '' ||
            (typeof value === 'object' && value !== null && Object.keys(value).length === 0) ||
            (Array.isArray(value) && value.length === 0)
        );
    }


}